import BaseService from './base-service.js'


export default {
    // Add google doc
    addGoogleDoc({ projectUuid, data }) {
        const resource = `projects/${projectUuid}/google-docs`
        return BaseService.post(`${resource}`, data);
    },

    // Auth google doc
    authGoogleDoc({ authId, authCode }) {
        const resource = `google-docs/_auth`
        return BaseService.post(`${resource}`, {authId, authCode} );
    },

    // search google docs
    searchGoogleDocs(params) {
        const resource = `google-docs/_search`
        return BaseService.post(`${resource}`, params ).then(resp => resp.data);
    },

    // Create google doc copy
    createGoogleDocCopy({ projectUuid, data }) {
        const resource = `projects/${projectUuid}/google-docs/_copy`
        return BaseService.post(`${resource}`, data).then(resp => resp.data);
    },

    // Add google doc localization
    addGoogleDocLocalization({ projectUuid, data }) {
        const resource = `projects/${projectUuid}/google-doc-localizations`
        return BaseService.post(`${resource}`, data).then(resp => resp.data);
    },

    // Add google doc permissions
    addGooglePermissions({ projectUuid, data }) {
        const resource = `projects/${projectUuid}/google-doc-permissions`
        return BaseService.post(`${resource}`, data);
    },

    // delete google doc
    deleteGoogleDoc({ projectUuid, externalId }) {
        const resource = `projects/${projectUuid}/google-docs/${externalId}`
        return BaseService.delete(`${resource}`);
    },
}
